var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticStyle:{"height":"100%"}},[_c('h1',[_vm._v(" Server error\n        "),_c('h3',[_vm._v(" Please check your internet connection and/or click on the button below ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.$router.reload()}}},[_vm._v("\n            Refresh\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47e559a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NetworkError.vue
// module id = null
// module chunks = 